/**
 * @method URL:_Static => This method will return given url for either production/ dev.
 */
export class Defaults {
    /**
     * 
     * @param url : Given URL will be prefixed with production/ dev url.
     * 
        stage - https://stage-api.bajajcapitalone.com/nps/
        dev - https://dev-api.bajajcapitalone.com/nps/ (edited) 
        prod - https://api.bajajcapitalone.com/nps/
        //https://dev-api.bajajcapitalone.com
     */
    // public static URL(url) {
    //     // if (/localhost/.test(window.location.origin)) return 'http://localhost:8005/nps/api/v1' + url;
    //     if (/localhost/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1' + url;
    //     // else if (/stage/.test(window.location.origin)) return 'https://stage-api.bajajcapitalone.com/nps/api/v1' + url;
    //     else if (/stage/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1' + url;
    //     else if (/dev/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1' + url;
    //     else return 'https://api.bajajcapitalone.com/nps/api/v1' + url;
    // }
    public static URL(url) {
        // if (/localhost/.test(window.location.origin)) return 'http://localhost:8005/nps/api/v1' + url;
        if (/localhost/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1' + url;
        else if (/stagenps|stage/.test(window.location.origin)) return 'https://stage-api.bajajcapitalone.com/nps/api/v1' + url;
        // else if (/stage/.test(window.location.origin)) return 'http://dev-api.bajajcapitalone.com/nps/api/v1' + url;
        else if (/devnps|dev/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1' + url;
        // else if (/nps/.test(window.location.origin)) return 'https://nps-api.bajajcapitalone.com/nps/api/v1' + url;
        else return 'https://nps-api.bajajcapitalone.com/nps/api/v1' + url;
    }
    public static CaptchaEndPoint() {
        let url = 'https://your-app-backend-hostname.your-domain.com/simple-captcha-endpoint';
        return (/localhost|stage/.test(window.location.origin) ? 'dev' : 'production') + url;
    }
    // public static KarvyURL() {
    //     //if (/localhost/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1/karvy';
    //     if (/localhost/.test(window.location.origin)) return 'http://localhost:8005/nps/api/v1/karvy';
    //     else if (/stage/.test(window.location.origin)) return 'https://stage-api.bajajcapitalone.com/nps/api/v1/karvy';
    //     else if (/dev/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1/karvy';
    //     else return 'https://api.bajajcapitalone.com/nps/api/v1/karvy';
    // }
    public static KarvyURL() {
        //if (/localhost/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1/karvy';
        if (/localhost/.test(window.location.origin)) return 'http://localhost:8005/nps/api/v1/karvy';
        else if (/stagenps/.test(window.location.origin)) return 'https://stage-api.bajajcapitalone.com/nps/api/v1/karvy';
        else if (/devnps/.test(window.location.origin)) return 'http://dev-api.bajajcapitalone.com/nps/api/v1/karvy';
        else return 'https://nps-api.bajajcapitalone.com/nps/api/v1/karvy';
    }
    // public static KarvyURLSubSequent() {
    //     //if (/localhost/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1/karvy/SubSequentContribution';
    //     if (/localhost/.test(window.location.origin)) return 'http://localhost:8005/nps/api/v1/karvy/SubSequentContribution';
    //     else if (/stage/.test(window.location.origin)) return 'https://stage-api.bajajcapitalone.com/nps/api/v1/karvy/SubSequentContribution';
    //     else if (/dev/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1/karvy/SubSequentContribution';
    //     else return 'https://api.bajajcapitalone.com/nps/api/v1/karvy/SubSequentContribution';
    // }
    public static KarvyURLSubSequent() {
        //if (/localhost/.test(window.location.origin)) return 'https://dev-api.bajajcapitalone.com/nps/api/v1/karvy/SubSequentContribution';
        if (/localhost/.test(window.location.origin)) return 'http://localhost:8005/nps/api/v1/karvy/SubSequentContribution';
        else if (/stagenps/.test(window.location.origin)) return 'https://stage-api.bajajcapitalone.com/nps/api/v1/karvy/SubSequentContribution';
        else if (/devnps/.test(window.location.origin)) return 'http://dev-api.bajajcapitalone.com/nps/api/v1/karvy/SubSequentContribution';
        else return 'https://nps-api.bajajcapitalone.com/nps/api/v1/karvy/SubSequentContribution';
    }

    public static GetCityURL() {
        if (/localhost/.test(window.location.origin)) return 'https://ftqdihckb5.execute-api.ap-south-1.amazonaws.com/prod/campaign/getcity';
        else if (/stagenps/.test(window.location.origin)) return 'https://ftqdihckb5.execute-api.ap-south-1.amazonaws.com/prod/campaign/getcity';
        else if (/devnps/.test(window.location.origin)) return 'https://ftqdihckb5.execute-api.ap-south-1.amazonaws.com/prod/campaign/getcity';
        else return 'https://ftqdihckb5.execute-api.ap-south-1.amazonaws.com/prod/campaign/getcity';
    }
    public static GetSalesForceURL() {
        if (/localhost/.test(window.location.origin)) return 'https://cmfyttqhhb.execute-api.ap-south-1.amazonaws.com/dev/campaign/pushLeads';
        else if (/stagenps/.test(window.location.origin)) return 'https://cmfyttqhhb.execute-api.ap-south-1.amazonaws.com/dev/campaign/pushLeads';
        else if (/devnps/.test(window.location.origin)) return 'https://cmfyttqhhb.execute-api.ap-south-1.amazonaws.com/dev/campaign/pushLeads';
        else return 'https://rqf5g3hbk5.execute-api.ap-south-1.amazonaws.com/prod/campaign/pushLeads';
    }
    public static GetNSDLURL() {
        let dev = "https://121.240.9.12/myNPS/InitialExistingUser.html?appType=main&authId=TlczM2p6Wm5XQlRZcXQrWXBobGtGUT09";
        let prod = "https://mynps.nps-proteantech.in/myNPS/InitialExistingUser.html?appType=main&authId=TlczM2p6Wm5XQlRZcXQrWXBobGtGUT09";

        if (/localhost/.test(window.location.origin)) return dev;
        else if (/stagenps/.test(window.location.origin)) return dev;
        else if (/devnps/.test(window.location.origin)) return dev;
        else return prod;
    }
      public static GetNSDLRetirmentURL() {
        let dev = "https://121.240.9.12/myNPS/NationalPensionSystemSIP.html?appType=main&authId=ZTZHWXZWVDRPcFNtYXJWRnNGeEx3QT09";
        // let prod = "https://mynps.nps-proteantech.in/myNPS/NationalPensionSystemSIP.html?appType=main&authId=ZTZHWXZWVDRPcFNtYXJWRnNGeEx3QT09";
        let prod = "https://mynps.nps-proteantech.in/myNPS/NationalPensionSystemSIP.html?appType=main&authId=TlczM2p6Wm5XQlRZcXQrWXBobGtGUT09";

        if (/localhost/.test(window.location.origin)) return dev;
        else if (/stagenps/.test(window.location.origin)) return dev;
        else if (/devnps/.test(window.location.origin)) return dev;
        else return prod;
    }
    
    public static GetNSDLCorpRegURL() {
        let dev = "https://121.240.64.238/CRAOnline/getOnlineEntyRegistration.html";
        let prod = "https://cra.nps-proteantech.in/CRAOnline/getOnlineEntyRegistration.html";

        if (/localhost/.test(window.location.origin)) return dev;
        else if (/stagenps/.test(window.location.origin)) return dev;
        else if (/devnps/.test(window.location.origin)) return dev;
        else return prod;
    }
    public static GetNSDLCorpEMPRegURL() {
        let dev = "https://121.240.9.12/myNPS/NationalPensionSystem.html?appType=main&authId=TlczM2p6Wm5XQlRZcXQrWXBobGtGUT09";
        // let prod = "https://mynps.nps-proteantech.in/myNPS/NationalPensionSystem.html?appType=main&authId=TlczM2p6Wm5XQlRZcXQrWXBobGtGUT09";
        let prod = "https://mynps360direct.nps-proteantech.in/diy?client=6b1f3e2d4c8a9f0b7e5d3c2a1f8b6d4e9c7a5b3d&secure=3d9a7c5b1e4f8a2c6d0b5e7f3a1c9d4b6e8f2a7c"

        if (/localhost/.test(window.location.origin)) return dev;
        else if (/stagenps/.test(window.location.origin)) return dev;
        else if (/devnps/.test(window.location.origin)) return dev;
        else return prod;
    }
    
    public static GetHomePageURL() {
        let dev = "https://devnps.bajajcapital.com/";
        let stage = "https://stagenps.bajajcapital.com/";
        let prod = "https://nps.bajajcapital.com/";

        if (/localhost/.test(window.location.origin)) return dev;
        else if (/stagenps/.test(window.location.origin)) return stage;
        else if (/devnps/.test(window.location.origin)) return dev;
        else return prod;
    }
    public static GetDefaultRMDetails(){
        return  {
            "RMName": "Digital Channel",
            "RMCode": "105648",
            "BranchCode": "10070352",
            "BranchName": "DIGITAL TRANSFORMATION"
          };
    }
    public static WebengageEncryption() {
        if (/localhost/.test(window.location.origin)) return 'https://dev-api.bajajcapital.com/bclcomapp/api/encryptData';
        else if (/stagenps/.test(window.location.origin)) return 'https://stage-api.bajajcapital.com/bclcomapp/api/encryptData';
        else if (/devnps/.test(window.location.origin)) return 'https://dev-api.bajajcapital.com/bclcomapp/api/encryptData';
        else return 'https://prod-api.bajajcapital.com/bclcomapp/api/encryptData';
    }
    public static SSO_url() {
        if (/localhost/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=1c7qp8o8b9ngr3k60bn3ff0o80';
        // else if (/stage/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=2ebpuei0sqvtg2tg7jor6l5oc7';
        // else if (/dev/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=2ebpuei0sqvtg2tg7jor6l5oc7';
        else if (/devnps/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=1c7qp8o8b9ngr3k60bn3ff0o80';
        else if (/stagenps/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=1c7qp8o8b9ngr3k60bn3ff0o80';
        // else if (/nps/.test(window.location.origin)) return 'https://sso.bajajcapital.com/sign-in?clientId=1cqfsjnesjc0trhbpdn5j7rgnt';
        else return 'https://sso.bajajcapital.com/sign-in?clientId=6omblm8dnlq7kfdog3f36h8fuv';
    }
    public static SSO_url_logout() {
        if (/localhost/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=1c7qp8o8b9ngr3k60bn3ff0o80&action=logout';
        // else if (/stage/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=5froh0mnnr3e0ftg1vkki1ds2e&action=logout';
        // else if (/dev/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=5froh0mnnr3e0ftg1vkki1ds2e&action=logout';
        else if (/devnps/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=1c7qp8o8b9ngr3k60bn3ff0o80&action=logout';
        else if (/stagenps/.test(window.location.origin)) return 'https://uat-sso.bajajcapital.com/sign-in?clientId=1c7qp8o8b9ngr3k60bn3ff0o80&action=logout';
        // else if (/nps/.test(window.location.origin)) return 'https://sso.bajajcapital.com/sign-in?clientId=1cqfsjnesjc0trhbpdn5j7rgnt&action=logout';
        else return 'https://sso.bajajcapital.com/sign-in?clientId=6omblm8dnlq7kfdog3f36h8fuv&action=logout';
    }

    public static SSO_decode_token(url) {
        if (/localhost/.test(window.location.origin)) return 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso' + url;
        else if (/devnps/.test(window.location.origin)) return 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso' + url;
        else if (/stagenps/.test(window.location.origin)) return 'https://7a6jaimwzb.execute-api.ap-south-1.amazonaws.com/uat/sso' + url;
        else return 'https://8e546jtycf.execute-api.ap-south-1.amazonaws.com/prod/sso' + url; 
        // need to change for PROD
    }
}
export interface CustomError {
    error?: string;
    success?: string;
    isError?: boolean;
    status?: boolean;
}
export const CAMP_NONKYC = "NPS_NONKYC";
export const CAMP_KYC = "NPS_KYC";
export const CAMP_KYC_CHANGE = "NPS_CHANGE_REQ";
